export default {
  countries (state) {
    const countries = JSON.parse(localStorage.getItem('edit/countries'))
    if (countries) {
      return countries
    }
    return state.countries
  },
  cities (state) {
    if (state.cities) {
      return state.cities
    }
    return []
  }
}
